// extracted by mini-css-extract-plugin
export default {"label":"rhfSwitch_label__a13tY"};